import _ from 'lodash';

export default class DisplayNameResolver {
  constructor(explicits, acronyms) {
    this._explicits = new Map();
    this._acronyms = new Set();

    if (explicits) {
      this.addExplicits(explicits);
    }

    if (acronyms) {
      this.addAcronyms(acronyms);
    }
  }

  addExplicits(explicits, options = {}) {
    const { update } = _.defaults(options, { update: true });

    Object.entries(explicits).forEach(([key, value]) => {
      const has = this._explicits.has(key);

      if ((has && update) || !has) {
        this._explicits.set(key, value);
      }
    });
  }

  addAcronyms(acronyms) {
    acronyms.forEach(e => this._acronyms.add(e));
  }

  resolve(name) {
    if (!_.isString(name)) return [name, false];
    else if (this._explicits.has(name)) return [this._explicits.get(name), true];
    else return this._format(name);
  }

  _format(name) {
    try {
      let words;
      let smartAcronyms = true;

      if (pascalCaseExpression.test(name)) {
        words = name.match(pascalCaseWords);
      } else if (upperSnakeCaseExpression.test(name)) {
        words = name.split('_');
        smartAcronyms = false;
      } else if (camelCaseExpression.test(name)) {
        words = name.match(camelCaseWords);
      } else {
        return [name, false];
      }

      return [
        words
          .map((word, i) => {
            if (this._acronyms.has(word)) return word;
            else if (smartAcronyms && word.length > 1 && _.upperCase(word) === word) return word;
            else if (i === 0) return _.capitalize(word);
            else return word.toLowerCase();
          })
          .join(' '),
        words.some(word => this._acronyms.has(word))
      ];
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error({ name, exception: e });
      return [name, false];
    }
  }
}

const upperSnakeCaseExpression = /^[A-ZÀ-ÖØ-Ý][A-ZÀ-ÖØ-Ý0-9_]*$/;
const camelCaseExpression = /^(?:[a-zà-öø-ÿ]|[A-ZÀ-ÖØ-Ý]{2,})[[a-zà-öø-ÿ0-9A-ZÀ-ÖØ-Ý\\.]*$/;
const camelCaseWords =
  /[a-zà-öø-ÿ0-9]+|[A-ZÀ-ÖØ-Ý]{2,}(?=[A-ZÀ-ÖØ-Ý\\.][a-zà-öø-ÿ0-9]*|$)|[A-ZÀ-ÖØ-Ý][a-zà-öø-ÿ0-9]*/g;
const pascalCaseExpression = /^(?:[A-ZÀ-ÖØ-Ý]+[a-zà-öø-ÿ0-9]+)+(?:$|[A-ZÀ-ÖØ-Ý]+)$/;
const pascalCaseWords =
  /[A-ZÀ-ÖØ-Ý][a-zà-öø-ÿ0-9]+|[A-ZÀ-ÖØ-Ý]{2,}(?=[A-ZÀ-ÖØ-Ý][a-zà-öø-ÿ0-9]*|$)|[A-ZÀ-ÖØ-Ý][a-zà-öø-ÿ0-9]*/g;
